import { handleActions } from "redux-actions";
import { initialHomeState } from "./initialHomeState";
import { HomeConstants } from "./homeConstants";
import {
  requestFail,
  requestPending,
  requestSuccess
} from "../../../utils/fetch";

export const homeReducer = handleActions(
  {
    [requestSuccess(HomeConstants.FETCH_USER_DETAILS)]: (
      state,
      action
    ) => ({
      ...state,
      details: action.payload.user || null,
      fetchUserDetailsLoading: false,
      fetchUserDetailsFailure: false,
      fetchUserDetailsLoaded: true
    }),
    [requestPending(HomeConstants.FETCH_USER_DETAILS)]: state => ({
      ...state,
      fetchUserDetailsLoading: true,
      fetchUserDetailsLoaded: false,
      fetchUserDetailsFailure: false
    }),
    [requestFail(HomeConstants.FETCH_USER_DETAILS)]: state => ({
      ...state,
      fetchUserDetailsLoading: false,
      fetchUserDetailsLoaded: true,
      fetchUserDetailsFailure: true
    })
  },
  initialHomeState()
);
